import type { TimelineNode } from "@/mocks/stories";

const KIND_STYLE: Record<TimelineNode["kind"], { dot: string; chip: string }> = {
  爆料: { dot: "bg-primary-500", chip: "bg-primary-100 text-primary-800" },
  回应: { dot: "bg-secondary-500", chip: "bg-secondary-100 text-secondary-800" },
  反转: { dot: "bg-accent-500", chip: "bg-accent-100 text-accent-900" },
  进展: { dot: "bg-foreground-500", chip: "bg-background-200 text-foreground-700" },
};

type TimelineProps = {
  nodes: TimelineNode[];
  dense?: boolean;
};

export default function Timeline({ nodes, dense = false }: TimelineProps) {
  return (
    <ol className="relative">
      {nodes.map((node, index) => {
        const style = KIND_STYLE[node.kind];
        const last = index === nodes.length - 1;
        return (
          <li key={`${node.time}-${index}`} className="relative flex gap-4">
            <div className="flex flex-col items-center">
              <span
                className={`mt-1.5 block h-3 w-3 shrink-0 rounded-full ring-4 ring-background-50 ${style.dot}`}
              />
              {!last ? (
                <span className="my-1 w-px flex-1 bg-background-300" aria-hidden="true" />
              ) : null}
            </div>
            <div className={`min-w-0 flex-1 ${last ? "pb-0" : dense ? "pb-5" : "pb-7"}`}>
              <div className="mb-1.5 flex flex-wrap items-center gap-2">
                <span
                  className={`rounded-md px-2 py-0.5 font-label text-xs font-medium ${style.chip}`}
                >
                  {node.kind}
                </span>
                <time className="font-label text-xs tabular-nums text-foreground-500">
                  {node.time}
                </time>
                {!node.verified ? (
                  <span className="flex items-center gap-1 rounded-md border border-dashed border-foreground-300 px-2 py-0.5 font-label text-xs text-foreground-500">
                    <i className="ri-error-warning-line" />
                    待核实
                  </span>
                ) : null}
              </div>
              <h4
                className={`font-heading font-bold text-foreground-950 ${
                  dense ? "text-sm" : "text-base"
                }`}
              >
                {node.title}
              </h4>
              <p
                className={`mt-1 leading-relaxed text-foreground-600 ${
                  dense ? "text-sm" : "text-sm md:text-[15px]"
                }`}
              >
                {node.desc}
              </p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}